import { WriteInvoiceSpecificationForm } from "@/schemas/invoiceSpecificationForm";
import { ReadLaborCostsInStoresInitial } from "@/types/laborCostsInStoresInitial";

export const mapInitialStores = <T extends ReadLaborCostsInStoresInitial>(
  items: T[],
  isDepartment: boolean,
): WriteInvoiceSpecificationForm["stores"] => {
  return items.map((item) => {
    const base = {
      store_id: item.store_id,
      hours: item.hours,
      deduction: item.deduction || "0",
      rate: item.rate,
      planned_hours: item.hours,
      include_on_invoice: true,
      addition: item.addition,
    };
    if (isDepartment) {
      return {
        ...base,
        ...("departments" in item && item.departments
          ? { departments: item.departments }
          : {}),
        ...("department_ids" in item && item.department_ids
          ? { department_ids: item.department_ids }
          : {}),
      };
    } else {
      return {
        ...base,
        ...("roles" in item && item.roles ? { roles: item.roles } : {}),
        ...("role_ids" in item && item.role_ids
          ? { role_ids: item.role_ids }
          : {}),
      };
    }
  });
};
